import {useState, useContext} from "react";
import {useNavigate} from "react-router-dom"
import { UserContext } from '../Context/UserContext';
import BatterIconLogo from "./BatterIconLogo";
import "../styles/login.css"

function Login({email, setEmail, password, setPassword}) {
    //const {state} = useContext(UserContext);
    const [errorsState, setErrorsState] = useState([])
    const navigate = useNavigate()
    const {login, isActiveSub} = useContext(UserContext)

    function handleSubmit(event) {
        event.preventDefault()
        fetch('/login', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        })
        .then(res => res.json())
        .then(user => {
            if (!user.errors) {
                login(user)

                const subscription = user.subscription
                //console.log('sub in Login', subscription)
                const toYMD = (d) => d.toISOString().slice(0, 10);  // “2025-04-17”
                const todayYMD = toYMD(new Date());
                //console.log('todayYMD in Login', todayYMD)
                //console.log('end_date in Login', subscription.end_date)
                const isActiveSub = todayYMD >= subscription.start_date && todayYMD <= subscription.end_date;
                //console.log('isActiveSub in Login', isActiveSub)

                if (isActiveSub) {
                    navigate('/ratings/hitters')
                }
                else {
                    navigate('/checkout')
                }
            }
            else {
                setEmail("")
                setPassword("")
                const errors = user.errors.map(e => <li className="errors">{e}</li>)
                setErrorsState(errors)
            }
        })
    }

    function navigateToSignUp() {
        navigate('/signup')
        window.scrollTo(0, 0)
    }

    function navigateToPasswordReset() {
        navigate('/password-reset')
        window.scrollTo(0, 0)
    }

    const form = (
        <>
            <form onSubmit={handleSubmit}>
                <label>Email Address</label>
                <br/>
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)}/>
                <br/>
                <label>Password</label>
                <br/>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                <br />
                <button className="submitButton" type="submit">Submit</button>
            </form>
            {errorsState.length > 0 && (errorsState)}
        </>
    )

    return (
        <div className="loginContainer">
            <BatterIconLogo logoID={"loginIconLogo"} />
            <div className="loginElements">
                <h2>Please Login</h2>
                {form}
                <h3>Don't Have an Account?</h3>
                <button onClick={navigateToSignUp}>Signup</button>
                <h3>Forgot Password?</h3>
                <button onClick={navigateToPasswordReset}>Reset It</button>
            </div>
        </div>
    )
}

export default Login